import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, useContext, useEffect } from 'react';

import './LinkWrapper.css';
import { SpeedbumpContext } from '../../providers/Speedbump/Speedbump';
import { getHostFromStringUrl } from '../../utils/cob-utils';
import { useModal, speedbumpModal } from '../../providers/Modal/Modal';
import { useWidthContext } from '../../providers/Width';
import { Button } from '../../importCL';
import SessionStorage from '../../utils/SessionStorage';


const isLinkInternal = (url: string): boolean => {
    return url.startsWith('#') || url.startsWith('/') || url.startsWith('./') || getHostFromStringUrl(url) === window.location.host;
};

const isTriggerSpeedbump = (url: string, whitelist: Array<string>): boolean => {
    const isWhitelisted = whitelist && whitelist.some(i => url.includes(i));
    if (isWhitelisted) {
        return false;
    }

    return !!url && !isLinkInternal(url);
};

const iFrameRedirectHandler = (url: string, target: '_blank' | '_self' | undefined) => {
    return (e: MouseEvent | React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        const messageData = {
            event: 'WrapperRedirect',
            url,
            target,
        };
        window.parent.postMessage(messageData, window.location.origin);
    };
};

const LinkWrapper = (props: AnchorHTMLAttributes<HTMLAnchorElement> & { disabled?: boolean }) => {
    const isInIFrame = window.self !== window.top;
    const { width } = useWidthContext();
    const { title, content, whitelist } = useContext(SpeedbumpContext);
    const { toggleModal, setModalContent, setModalClass } = useModal();
    
    let externalUrl: string | undefined = '';
    let target: '_blank' | '_self' | undefined;

    if (isTriggerSpeedbump(props.href || '', whitelist)) {
        externalUrl = props.href;
    }
    if (props.target === '_blank' || props.target === '_self' || props.target === undefined) {
        target = props.target as '_blank' | '_self' | undefined;
    }

    function clickHandler(e: any) {
        e.preventDefault();
        if (props.href.includes('creditoneinsurance') && !(window.location.href.includes('c1insurance')) && width <= 768) {
            SessionStorage.set('insuranceURL', props.href);
            window.location.assign('/content/cob-corp-acquisition/us/en/c1insurance/transition.html');
        } else if (!isInIFrame) {
            setModalContent(speedbumpModal(toggleModal, width, target, externalUrl, title, content));
            toggleModal();
        } else {
            const messageData = {
                event: 'Speedbump',
                externalUrl,
                title,
                content,
                width,
                target,
            };
            window.parent.postMessage(messageData, window.location.origin);
        }
    }

    useEffect(() => {
        setModalClass('Speedbump');
    }, []);

    if (externalUrl) {
        return <a {...props} onClick={clickHandler} className={`${props.className} Speedbump__link`} />;
    } else if (isInIFrame) {
        return <a {...props} onClick={iFrameRedirectHandler(props.href as string, props.target as '_blank' | '_self' | undefined)} />;
    } 
    return <a {...props} />;
    
};
LinkWrapper.displayName = 'LinkWrapper';

// @ts-ignore
const ButtonWrapper = (props: IButtonProps & AnchorHTMLAttributes<any> & ButtonHTMLAttributes<any>): JSX.Element => {
    const isInIFrame = window.self !== window.top;
    const { width } = useWidthContext();
    const { title, content, whitelist } = useContext(SpeedbumpContext);
    const { toggleModal, setModalContent, setModalClass } = useModal();
    let externalUrl: string | undefined  = '';

    useEffect(() => {
        setModalClass('Speedbump');
    }, []);

    if (isTriggerSpeedbump(props.href || '', whitelist)) {
        externalUrl = props.href;
    }

    const clickHandler = (e: any) => {
        e.preventDefault();
        if (window.location.href.includes('c1insurance/transition')) {
            window.location.assign(props.href);
        } else if (!isInIFrame) {
            setModalContent(speedbumpModal(toggleModal, width, props.target, externalUrl, title, content));
            toggleModal();
        } else {
            const messageData = {
                event: 'Speedbump',
                externalUrl,
                title,
                content,
                width,
                target: props.target,
            };
            window.parent.postMessage(messageData, window.location.origin);
        }
    };

    if (externalUrl) {
        return <Button {...props} onClick={clickHandler} className={`${props.className} Speedbump__button`} />;
    } else if (isInIFrame) {
        return <Button {...props} onClick={iFrameRedirectHandler(props.href, props.target)} />;
    } 
    return <Button {...props} />;
    
};

export {
    LinkWrapper,
    ButtonWrapper,
    speedbumpModal,
};
        